import { useLanguage } from '@/i18n';
import { cn } from '@/lib/cn';

interface LanguageSwitcherProps {
  variant?: 'pill' | 'select';
  className?: string;
}

/**
 * Türkçe / İngilizce dil seçim bileşeni.
 */
export function LanguageSwitcher({ variant = 'pill', className }: LanguageSwitcherProps) {
  const { lang, setLanguage, t } = useLanguage();

  if (variant === 'select') {
    return (
      <select
        value={lang}
        onChange={(event) => setLanguage(event.target.value as 'tr' | 'en')}
        aria-label={t('lang.selectLanguage')}
        className={cn(
          'rounded-xl border border-slate-300 bg-white px-2 py-1 text-xs font-semibold text-slate-700 hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-primary-500',
          className,
        )}
      >
        <option value="tr">TR — Türkçe</option>
        <option value="en">EN — English</option>
      </select>
    );
  }

  return (
    <div
      className={cn(
        'inline-flex items-center rounded-xl border border-slate-200 bg-slate-100/90 p-0.5 text-xs font-bold text-slate-600 shadow-inner',
        className,
      )}
      role="group"
      aria-label={t('lang.selectLanguage')}
    >
      <button
        type="button"
        onClick={() => setLanguage('tr')}
        className={cn(
          'rounded-lg px-2 py-1 transition-all',
          lang === 'tr'
            ? 'bg-white text-primary-900 shadow-sm font-extrabold'
            : 'text-slate-500 hover:text-slate-900',
        )}
        aria-pressed={lang === 'tr'}
        aria-label="Türkçe"
      >
        TR
      </button>
      <button
        type="button"
        onClick={() => setLanguage('en')}
        className={cn(
          'rounded-lg px-2 py-1 transition-all',
          lang === 'en'
            ? 'bg-white text-primary-900 shadow-sm font-extrabold'
            : 'text-slate-500 hover:text-slate-900',
        )}
        aria-pressed={lang === 'en'}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
}
